import React, { useState } from 'react';
import {Link, useNavigate} from "react-router-dom";
import {useForm} from "react-hook-form";
import {toast} from "react-toastify";
import MechanicAPI from "../../apis/maintainerApi/MaintainerAPI";
import Field from "../forms/Field";
import MyButton from "../assets/MyButton";

const AddBrand = () => {

    const { formState } = useForm();
    const { isSubmitting } = formState;
    const navigate = useNavigate();
    const [showLoader, setShowLoader] = useState(false);

    const [brand, setBrand] = useState({
        brand_name : ""
    });

    const [errors, setErrors] = useState({
        brand_name : ""
    });

    //Gestion de changement des inputs dans le formulaire
    const handleChange = ({currentTarget}) => {
        const {name, value} = currentTarget;
        setBrand({...brand, [name] : value})
    };



    let redirect = "mechanics";



    const handleSubmit = async (event) => {
        event.preventDefault();

        try{

            setShowLoader(true);
            await MechanicAPI.createBrands(brand);
            setTimeout(() => setShowLoader(false), 1000);
            toast.success("Genre modifié avec succès");
            navigate('/maintainer/brands')
        }catch({response}){
            setTimeout(() => setShowLoader(false), 1000);
            const {violations} = response.data;
            const {error} = response.data;

            if(violations){
                const apiErrors = {};
                Object.keys(violations).forEach(key => {
                    apiErrors[key] = violations[key]
                });

                setErrors(apiErrors);
                toast.error("Une erreur est servenue dans le formulaire de la modification du genre !");
            }else if (error) {
                toast.error(error);
            }
        }
    };


    return (
        <div className="container">
            <div className="row">
                <div className="col-md-5">
                    <div className="card">
                        <form onSubmit={handleSubmit}>
                            <div className="card-body">
                                <h5 className="card-title">Ajouter un genre de bus</h5>
                                <Field
                                    name="brand_name"
                                    error={errors.brand_name}
                                    value={brand.brand_name}
                                    onChange={handleChange}
                                    label="Nom Complet"
                                />


                                <MyButton
                                    text="Ajouter"
                                    onSubmit={handleSubmit}
                                    loading={showLoader}
                                    disabled={showLoader}
                                />
                                <Link to={`/maintainer/${redirect}`} className="btn btn-danger mx-2">Annuler</Link>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddBrand;
